<template>
  <div class="about">
    <h1>This is an about page</h1>
  </div>
</template>
<script>
export default {
  data: () => ({
  }),
  mounted() {
    this.getApi();
  },
  methods: {
    getApi() {
      try {
        const params = new FormData();
        //params.append('entry_no'    , this.propsData.entry_no);

        this.$http.get(process.env.VUE_APP_URL+"db_connect.asp", params)
        .then((response) => {
          console.log(response)
/*          
          if (response.data.error === 'Y') {
            this.dataExist = false;
          } else {
            this.dataExist = true;
            //if(response.data.viewData) {
              this.itemList = response.data.judgeItems;
              for (var key in this.itemList) {
                if(key.indexOf("item") !== -1 && this.itemList[key] !== '') {
                  this.items.push(this.itemList[key]);
                }
              }
          }
*/          
        })
      } catch (error) {
        this.$alert(error, "Occur Error!!!!!!", "warning");
      }
    }
  }
}
</script>